export const castToBoolean = value => {
  if (value === true || value === false) return value;
  if (value == null) return false;

  if (typeof value === 'number') return value !== 0;

  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    if (['true', '1', 't', 'yes', 'y'].includes(v)) return true;
    if (['false', '0', 'f', 'no', 'n', ''].includes(v)) return false;
  }

  return Boolean(value);
};

export const isSilentMessage = obj => {
  const ca = obj?.content_attributes;
  if (!ca) return false;

  if (typeof ca === 'string') {
    try {
      const parsed = JSON.parse(ca);
      return castToBoolean(parsed?.silent);
    } catch (_) {
      return false;
    }
  }

  return castToBoolean(ca?.silent);
};
